import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import 'moment/locale/nl';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'dateFormat' })
export class DateFormatPipe implements PipeTransform {
  constructor(private _translate: TranslateService) {}

  transform(value: Date | string, format?: string): string {
    if (!value) {
      return null;
    }

    const momentDate = moment(value, 'DD-MM-YYYY', true);
    momentDate.locale(this._translate.currentLang || 'nl');

    if (momentDate.isValid()) {
      return momentDate.format(format ? format : 'D MMMM YYYY');
    } else {
      console.error('Invalid date format:', value);
      return null;
    }
  }
}
